import React from "react";
import cx from "classnames";
import "./CardList.scss";
export function CardList({ children, className, style, shadowStyle = true, }) {
    const classes = cx(className, "card-list", {
        "shadow-style": shadowStyle,
    });
    return (React.createElement("div", { className: classes, style: style }, children));
}
